<template>
  <Modal :id="'editMaterialModal' + id" :savePromise="save" :prepareFunc="prepare">
    <template #button>
      <span style="cursor: pointer; color: black; font-size: 15px;"><i class='fa fa-edit'></i>編輯</span>
    </template>
    <!-- Modal -->
    <template #content>
      <div class="modal-body">
        <div class="container-fluid" id="existing_materials" v-show="isShowFile">
          <div class="row">
            <div class="col-xs-11">
              <label class="form-label label_text" style="font-size:medium;">學習資源:</label>
            </div>
            <div class="col-xs-1">
              <button class="mdl-button mdl-js-button mdl-button--fab mdl-button--mini-fab mdl-button--colored" style="float: right; background: darkgreen;" @click="goAddFile"><i class="material-icons">add</i></button>
            </div>
          </div>
          <div class="row" id="file_container">
            <div class="col-md-12 material" v-for="file in showFiles" :key="file.id+Math.random()" :id="file.id">
              <i class="fa fa-remove" @click="deleteFile" style="cursor: pointer;"></i>
              <span>{{file.name}}</span>
            </div>
          </div>
          <div class="form-group row" style="padding-bottom: 30px;">
            <div class="col-xs-6" style="text-align: center;">
               <el-button plain data-dismiss="modal">取消</el-button>
            </div>
            <div class="col-xs-6" style="text-align: center;">
               <el-button class="save-btn" type="primary" data-dismiss="modal">儲存</el-button>
            </div>
          </div>
        </div>
        <div class="container-fluid" id="new_materials" v-show="isAddFile">
          <form id="edit_form_material" method="POST">
            <div class="row">
              <div class="col-md-12">
                <label class="form-label label_text" style="font-size:medium;">上載資源:</label>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12">
                <md-field>
                  <label>檔案名稱</label>
                  <md-input v-model="newFileName"></md-input>
                </md-field>
              </div>
            </div>
            <div class="row">
              <md-field>
                <label>上載檔案</label>
                <md-file :id="'targetFile' + id" v-model="targetFile" />
              </md-field>
            </div>
            <div class="form-group row" style="padding-bottom: 30px;">
              <div class="col-xs-6" style="text-align: center;">
                 <el-button plain @click="cancelAdd">取消</el-button>
              </div>
              <div class="col-xs-6" style="text-align: center;">
                 <el-button type="primary" @click="addFile">新增</el-button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </template>
  </Modal>
</template>
<script>
import Modal from '@/components/Utility/Modal'
import $ from 'jquery'
export default {
  components: {
    Modal
  },
  props: {
    fileProps: Array,
    route: String,
    id: Number,
    update: {
      type: Function,
      default: () => {}
    }
  },
  data () {
    return {
      // showFiles: [],
      fileUpload: [], // file obj array
      fileDelete: [], // id array
      targetFile: '',
      isShowFile: true,
      isAddFile: false,
      newFileName: '',
      newId: -1,
      tem: 0
    }
  },
  computed: {
    showFiles: function () {
      let files = [].concat(this.fileProps).concat(this.fileUpload)
      this.fileDelete.forEach(fileId => {
        let index = files.findIndex(f => {
          return parseInt(f.id) === parseInt(fileId)
        })
        files.splice(index, 1)
      })
      return files
    }
  },
  methods: {
    addFile: function () {
      if (this.newFileName.length === 0) {
        alert('請輸入檔案名稱')
        return
      }
      let files = document.getElementById('targetFile' + this.id).files
      if (files.length === 0) {
        alert('請選擇上載檔案')
        return
      }
      this.isShowFile = true
      this.isAddFile = false
      this.fileUpload.push({
        name: this.newFileName,
        id: this.getUploadAutoId(),
        file: files[0]
      })
      document.getElementById(`targetFile${this.id}`).value = ''
    },
    cancelAdd: function () {
      this.isShowFile = true
      this.isAddFile = false
      this.targetFile = null
      document.getElementById(`targetFile${this.id}`).value = ''
      console.log(this.targetFile)
    },
    goAddFile: function () {
      this.isShowFile = false
      this.isAddFile = true
      this.newFileName = ''
      this.targetFile = null
    },
    deleteFile: function (e) {
      let file = $(e.target).closest('.material')
      let fileId = file.attr('id')
      if (fileId > 0) {
        this.fileDelete.push(file.attr('id'))
      }
      let index = this.fileUpload.findIndex(f => parseInt(f.id) === parseInt(file.attr('id')))
      if (index >= 0) {
        this.fileUpload.splice(index, 1)
      }
      this.checkHaveChange()
      e.stopPropagation()
    },
    save: async function () {
      try {
        let uploadRequsets = this.fileUpload.map(v => {
          let fd = new FormData()
          fd.append('type', 'File')
          fd.append('name', v.name)
          fd.append('description', 'hard-code description')
          fd.append('upload_material', v.file)
          return this.$store.dispatch('request', {
            method: 'post',
            route: this.route,
            data: fd
          })
        })
        let deleteRequsets = this.fileDelete.map(id => {
          return this.$store.dispatch('request', {
            method: 'delete',
            route: this.route + `/${id}`
          })
        })
        let requests = uploadRequsets + deleteRequsets
        for (var i = 0; i < requests; i++) {
          await requests[i]
        }
      } catch (err) {
        alert('失敗')
        return false
      }
      alert('成功')
      this.update()
      // console.log(this.fileUpload)
      // this.fileUpload.forEach(file => {
      //   this.fileProps.push(file)
      // })
      // this.fileDelete.forEach(id => {
      //   if (id > 0) {
      //     let index = this.fileProps.findIndex(f => f.id === id)
      //     this.fileProps.splice(index, 1)
      //   }
      // })
      // console.log(this.fileProps)
      return true
      // $('#editMaterialModal' + this.id).modal('hide')
    },
    getUploadAutoId: function () {
      return this.newId--
    },
    checkHaveChange: function () {
      let hvFileUpload = this.fileUpload.length > 0
      let hvFileDelete = this.fileDelete.filter(f => f.id !== -1).length > 0
      if (!hvFileUpload && !hvFileDelete) {
        $('body').attr('have_change', 'false')
      }
    },
    prepare: function () {
      this.fileUpload = []
      this.fileDelete = []
      this.isShowFile = true
      this.isAddFile = false
      document.getElementById(`targetFile${this.id}`).value = ''
      this.newFileName = ''
    }
  },
  watch: {
    isShowFile: function (isShowFile) {
      if (isShowFile) {
        this.checkHaveChange()
      }
    }
  }
}
</script>
